import Module from "../../../../../hebelsolar-md/src/classes/Module.js";
var debug = false;

class Inverter {
        id= "";
        deviceType= "inverter";
        code= ""; 
        description="" ;
        manufacturer= "";
        warranty = 0;
        performanceWarranty = 0;
        needStringBox= true;
        efficiency= 97.8;
        weight= 80;
        height= 705;
        width= 650;
        depth= 283;
    
        acPower=  3; 
        acVoltage= 380; 
        acPhases= 3; 
        acMaxCurrent= 13; 
    
        dcMinPower= 2.1;
        dcMaxPower= 3.96; 
        dcMaxVoltage =500;
        quantity= 0;

        nMax= 0;
        nMin= 0;
        unit = "peça (s)"
        mppts= [
        {
            dcMinOpVoltage: 250,//Min operation voltage
            dcMaxOpVoltage: 1000, //Max operation voltage
            dcMaxVoltage: 1100,
            dcMaxCurrent: 36,
            sMax: 3
        },
        {
            dcMinOpVoltage: 250,//Min operation voltage
            dcMaxOpVoltage: 1000, //Max operation voltage
            dcMaxVoltage: 1100,
            dcMaxCurrent: 36,
            sMax: 3
        }
        ,
        {
            dcMinOpVoltage: 250,//Min operation voltage
            dcMaxOpVoltage: 1000, //Max operation voltage
            dcMaxVoltage: 1100,
            dcMaxCurrent: 36,
            sMax: 3
        }
        ,
        {
            dcMinOpVoltage: 250,//Min operation voltage
            dcMaxOpVoltage: 1000, //Max operation voltage
            dcMaxVoltage: 1100,
            dcMaxCurrent: 36,
            sMax: 3
        }
    
    ];

        dcWiring= {};
        product = { 
            price:0,
            cost:0,
           // taxes:0,
            sellerId:"", //Now its a string
            available:true, //editted by the user
            we:{
                ativoMatriz:false,
                ativoIntegrador:false,
                ativoFranquia:false,
                custoUsdAtivo:false,
                custoUsd:0,
                precoTargetUsd:0,
        
              }
        };



        constructor(){
        };

        clone(object){   
            Object.assign(this, object );   
        }

        loadFromInversor(i){
            if(i._id){
                //alert(JSON.stringify(m._id))
                this.id = i._id.$oid;
              }else{
                alert(JSON.stringify(i._id))
                
              }
              
            this.deviceType = "inverter";
            this.code = i.codigoFabricante;
            this.description = i.descricao;
            this.manufacturer = i.fabricante;
            this.needStringBox = i.stringbox == 1;
            if(i.rendimento)
                this.efficiency = i.rendimento;
            if(i.eficiencia)
                this.efficiency = i.eficiencia;
            
            this.weight = i.peso;
            this.height = i.altura;
            this.width = i.largura;
            this.depth = i.profundidade;
            // this.ac = {
            //             power: i.potenciaAc,  
            //             voltage: i.tensaoAc,
            //             phases: i.fases,
            //             maxCurrent: i.correnteMaxAc
            // },
            // this.dc = {
            //             minPower: i.potenciaMinDc,
            //             maxPower : i.potenciaMaxDc,
            //             maxVoltage :i.tensaoMaxDc,
            // }
            this.acPower = i.potenciaAc;  
            this.acVoltage = i.tensaoAc;
            this.acPhases =  i.fases;
            this.acMaxCurrent = i.correnteMaxAc;
            this.dcMinPower =  i.potenciaMinDc;
            this.dcMaxPower =  i.potenciaMaxDc;
            this.dcMaxVoltage  = i.tensaoMaxDc;
            if(i.qtd )
                this.quantity = i.qtd;
            //Add mppts
            this.mppts = [];
                for(var a = 0; a< i.mppts.length ; a++){
                    this.mppts.push(
                        { 
                            dcMinOpVoltage: i.mppts[a].tensaoMin,
                            dcMaxOpVoltage: i.mppts[a].tensaoMax,
                            dcMaxVoltage: i.mppts[a].tensaoMax,
                            dcMaxCurrent: i.mppts[a].correnteMax,
                            sMax: i.mppts[a].nStrings
                        
                        }
                    )
                };
            
                      
                this.product.priceTarget = i.precoTarget;
                this.product.cost = i.custo; 
                this.product.sellerId = i.fabricante;
                this.product.crmId=i.ploomesId;
                this.product.erpId = i.codRef;
        
                this.product.we.ativoFranquia= i.ativoFranquia;
                this.product.we.ativoIntegrador = i.ativoIntegrador;
                this.product.we.ativoMatriz= i.ativoMatriz;
                if(i.custoUsdAtivo){
                    this.product.we.custoUsdAtivo = i.custoUsdAtivo;
                this.product.we.custoUsd= i.custoUs;
                this.product.we.precoTargetUsd = i.precoTargetUsd;
                }
        
           
        }
        
        //module
        addDcWiring( ) {
            var module = new Module();
            if(debug) console.log("addDcWiring")
            var tMin = 0.0; 
            var tMax = 70.0;

            var dcWiring = {
                                module: Object.assign({}, module),
                                mppts:[],
                                //activeOption:0,
                                //activeWiring:0,
                                
            };
        
            module.voc_tMin = (1 - module.coefVoc / 100 * (tMin - 25.0)) * module.voc;
            module.vmp_tMax = (1 - module.coefVmp / 100 * (tMax - 25.0)) * module.vmp;
            if(debug)console.log("Math.floor(this.mppts[i].dcMaxVoltage"+ Math.floor(this.mppts[0].dcMaxVoltage ))
            if(debug)console.log("module.voc_tMin)"+ module.voc_tMin)

            for (var i = 0; i < this.mppts.length; i++) {
                //.limits.sMax
                //.limits.mMax
                //  m = modulos em serie
                // s= strings

                var  m = {  
                    // limits:{
                    //     numberOfStrings:{max:Math.floor( this.mppts[i].dcMaxCurrent / module.isc)},
                    //     numberOfModulesPerString:{           
                    //         min: Math.ceil(this.mppts[i].dcMinOpVoltage / module.vmp_tMax),         
                    //         max:Math.floor(this.mppts[i].dcMaxVoltage / module.voc_tMin) }
                    // }
                    limits:{
                        sMax :Math.floor( this.mppts[i].dcMaxCurrent / module.isc),
                        mMin:Math.ceil(this.mppts[i].dcMinOpVoltage / module.vmp_tMax),
                        mMax:Math.floor(this.mppts[i].dcMaxVoltage / module.voc_tMin)
                    }

                    
                }
                if( this.mppts[i].sMax < m.limits.sMax)
                    m.limits.sMax =  this.mppts[i].sMax;


                dcWiring.mppts.push( m )
            }
            
            if(debug)console.log(JSON.stringify(dcWiring))

            //Create connection options and quantity options
            for (var t = 0; t< dcWiring.mppts.length ; t++){
                var options = [{n:0, active:true, wirings:[{s:0, m:0, n:0} ] }  ];

                for (var s = 1; s<= dcWiring.mppts[t].limits.sMax ; s++  ){
                    for (var m =dcWiring.mppts[t].limits.mMin; m<=dcWiring.mppts[t].limits.mMax; m++){
                        var wiringOption = {s:s, m:m, n:s*m}
                        options = this.insertWiringOption(options, wiringOption)
                    }
                }
                dcWiring.mppts[t].options = options;
                dcWiring.mppts[t].activeOption = 0;
                dcWiring.mppts[t].activeWiring = 0;         
            }
            dcWiring.nModules = 0;
            dcWiring.dcPower = 0;

            this.nMax = 0 ;
            this.nMin = 0 ;

            if(debug)console.log("dcWiring.mppts:"  + JSON.stringify(dcWiring.mppts[0].limits))
            for (var a = 0; a < dcWiring.mppts.length; a++) {
             
                if(debug)console.log("a:"  + a);
                this.nMax += dcWiring.mppts[a].limits.mMax * dcWiring.mppts[a].limits.sMax;
                this.nMin += dcWiring.mppts[a].limits.mMin;
                if(debug)console.log("this.nMax:"  + this.nMax);
                if(debug)console.log("this.nMin:"  + this.nMin);
            
            }
            if (this.dcMinPower < this.nMin * module.dcPower )
                this.dcMinPower =  Math.round( this.nMin * module.dcPower*100)/100;

            if (this.dcMaxPower > this.nMax * module.dcPower )
                this.dcMaxPower =  Math.round(   this.nMax * module.dcPower * 100)/100;

            this.dcWiring = dcWiring;


        };
        insertWiringOption(options, wiringOption){
            for (var a= 0; a< options.length;a++){     
                if (options[a].n == wiringOption.n){
                    options[a].wirings.push(wiringOption);
                    return options;
                }
            }
            options.push({n:wiringOption.n,  active:false, wirings:[wiringOption]});
            return options;
            
        };


}




export default Inverter;
